/**
 * B010050 受注ワーク取込
 */
import { Column } from "@material-table/core";
import { Box } from "@mui/system";
import {
  B000140AssistantNm,
  B000140TantoushaNm,
  B010050CheckRequest,
  B010050EdiJuchuDataHandsRequest,
  B010050EdiJuchuDataLoftRequest,
  B010050EdiJuchuDataRequest,
  B010050ImportCheckgeneric,
  B010050ImportCheckhands,
  B010050ImportCheckloft,
  B010050ImportGeneric,
  B010050ImportGenericRequest,
  B010050ImportHands,
  B010050ImportHandsRequest,
  B010050ImportLoft,
  B010050ImportLoftRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialogAction,
  SDateField,
  SFileButton,
  SFileField,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  STable,
  SText,
  STextArea,
  STextField,
} from "components";
import { getClientError, getClientMessage } from "messages";
import { B010050TorikomidetaKbn, getSCode, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B000140 } from "pages/b000/B000140";
import { createRef, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { dateWithSlashAt, outputText } from "services";
import { authState, focusState, navigateTypeState, useFocus } from "states";
import { B010070InputData } from "./B010070";

// TODO 確認ダイアログのキャンセルボタンの無くし方

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  torikomidetaKbn: SCode;
  fileUploadArea: File;
  result: string;
  seisakuYmd: string;
  hasouYmd: string;
  denpyoYmd: string;
  nohinyoteiYmd: string;
  tantoushaCd: string;
  tantoushaNm: string;
  assistantCd: string;
  assistantNm: string;
}>;

// 東急ハンズの受注データ保持用フィールド
type CheckedDataHandsFields = Partial<{
  csvFileNm: string;
  ediJuchuDataList: EdiJuchuDataHandsFields[];
  displayDataList: DisplayData[];
}>;

// 東急ハンズの受注データ保持用フィールド内容
type EdiJuchuDataHandsFields = Partial<{
  hachuYmd: string;
  miseCd: string;
  torihikiShohinCd: string;
  shohinNm1: string;
  shohinNm2: string;
  hachusu: string;
  gentanka: string;
  uritanka: string;
  denpyoNo: string;
  denpyoGyo: string;
  floarNm: string;
  nohinbasho: string;
  teikyo1: string;
  teikyo2: string;
  tokuiCd: string;
  tokuishitenCd: string;
}>;

// ロフトの受注データ保持用フィールド
type CheckedDataLoftFields = Partial<{
  csvFileNm: string;
  ediJuchuDataList: EdiJuchuDataLoftFields[];
  displayDataList: DisplayData[];
}>;

// ロフトの受注データ保持用フィールド内容
type EdiJuchuDataLoftFields = Partial<{
  hachuTenpo: string;
  hachuYmd: string;
  juchuYmd: string;
  juchuTime: string;
  denpyoNo: string;
  hinbetsuNo: string;
  biko: string;
  janCd: string;
  shohinNm: string;
  hachusu: string;
  hachugentanka: string;
  hachuuritanka: string;
  tokuiCd: string;
  tokuishitenCd: string;
}>;

// 汎用受注データ保持用フィールド
type CheckedDataGenericFields = Partial<{
  csvFileNm: string;
  ediJuchuDataList: EdiJuchuDataGenericFields[];
  displayDataList: DisplayData[];
}>;

// 汎用受注データ保持用フィールド内容
type EdiJuchuDataGenericFields = Partial<{
  juchuNo: string;
  juchuYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  chohaKbn: string;
  seisakuYmd: string;
  denpyoYmd: string;
  shukayoteiYmd: string;
  nohinyoteiYmd: string;
  biko: string;
  edimemo: string;
  chumonNo: string;
  hinbetsuNo: string;
  nohinsaki: string;
  uribaNm: string;
  naisen: string;
  tantosha: string;
  lineCd: string;
  nonyuNm: string;
  nonyuPostCd: string;
  nonyuAddress1: string;
  nonyuAddress2: string;
  nonyuTelNo: string;
  nonyuFaxNo: string;
  shohinCd: string;
  juchusu: string;
  juchutanka: string;
  juchuKin: string;
  jodaitanka: string;
  kakeritsu: string;
  meisaibiko: string;
}>;

// テーブルデータ定義
type DisplayData = Partial<{
  gyoNo: number;
  denpyoNo: string;
  tokuiNm: string;
  juchuYmd: string;
  meisaisu: string;
  biko: string;
}>;

// テーブルを定義する。
const columns: Column<DisplayData>[] = [
  { field: "gyoNo", title: "No　", width: "0.8rem", align: "right" },
  { field: "denpyoNo", hidden: true },
  { field: "tokuiNm", title: "得意先", width: "6rem" },
  { field: "juchuYmd", title: "受注日", width: "3rem" },
  { field: "meisaisu", title: "明細件数　", width: "1.5rem", align: "right" },
  { field: "biko", title: "備考", width: "10rem" },
];

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  torikomidetaKbn: getSCode(B010050TorikomidetaKbn, "1"),
  fileUploadArea: undefined,
  result: "",
  seisakuYmd: "",
  hasouYmd: "",
  denpyoYmd: "",
  nohinyoteiYmd: "",
  tantoushaCd: "",
  tantoushaNm: "",
  assistantCd: "",
  assistantNm: "",
};

// 東急ハンズ受注データ初期値
const defaultCheckedDataHandsFields: CheckedDataHandsFields = {
  csvFileNm: "",
  ediJuchuDataList: undefined,
  displayDataList: undefined,
};

// ロフト受注データ初期値
const defaultCheckedDataLoftFields: CheckedDataLoftFields = {
  csvFileNm: "",
  ediJuchuDataList: undefined,
  displayDataList: undefined,
};

// 汎用受注データ初期値
const defaultCheckedDataGenericFields: CheckedDataGenericFields = {
  csvFileNm: "",
  ediJuchuDataList: undefined,
  displayDataList: undefined,
};

const focusId = "B010050";

// B010050 受注ワーク取込
export const B010050 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // テーブルの値取得用Ref
  const tableRef = createRef();
  const [rows, setRows] = useState<DisplayData[]>([]);
  // 画面遷移
  const navigate = useNavigate();
  const [menuNavigate, setMenuNavigate] = useRecoilState(navigateTypeState);
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // 東急ハンズのフォーム
  const checkedDataHandsMethods = useForm<CheckedDataHandsFields>({
    mode: "onBlur",
    defaultValues: defaultCheckedDataHandsFields,
  });
  // ロフトのフォーム
  const checkedDataLoftMethods = useForm<CheckedDataLoftFields>({
    mode: "onBlur",
    defaultValues: defaultCheckedDataLoftFields,
  });
  // 汎用受注のフォーム
  const checkedDataGenericMethods = useForm<CheckedDataGenericFields>({
    mode: "onBlur",
    defaultValues: defaultCheckedDataGenericFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 読み込みボタン活性制御
  const disabledReadButton = methods.watch("fileUploadArea") === undefined;
  // 結果レポート出力ボタン活性制御
  const [disabledReportButton, setDisabledReportButton] = useState(true);
  // 登録ボタン活性制御
  const [disabledCreateButton, setDisabledCreateButton] = useState(true);
  // ヘッダ情報一括設定部活性制御
  const [disabledHedder, setDisabledHedder] = useState(true);
  // ログインユーザー情報
  const auth = useRecoilValue(authState);
  // 確認ダイアログのステート
  // 登録完了メッセージのダイアログ
  const [openCreateConfirm, setOpenCreateConfirm] = useState(false);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  });

  // 読込ボタンクリックイベント
  const handleClickReadButton = () => {
    //フォームデータ取得
    const fields = methods.getValues();

    methods.setValue("result", getClientMessage("B010050_001"));

    // 東急ハンズEDIの場合
    if (fields.torikomidetaKbn?.value === "1") {
      handleTokyuhandsEdiCheck(fields);
    }
    // ロフトEDIの場合
    else if (fields.torikomidetaKbn?.value === "2") {
      handleLoftEdi(fields);
    }
    // 汎用フォーマットの場合
    else if (fields.torikomidetaKbn?.value === "3") {
      handleGeneric(fields);
    }

    setDisabledReportButton(false);
  };

  // 東急ハンズEDIチェック
  const handleTokyuhandsEdiCheck = (fields: Fields) => {
    const param: B010050CheckRequest = {
      csvFileData: fields.fileUploadArea!,
    };

    B010050ImportCheckhands(param)
      .then((value) => {
        // 取込結果表示
        methods.setValue("result", value.data.torikomikeka);
        if (value.data.displayDataList) {
          // チェックしたデータの格納作業
          handleDataSaveTokyuhandsEdi(value.data);
          // グリッド作成
          handleGridCreate(value.data.displayDataList);
          // ヘッダ入力部活性化
          setDisabledHedder(false);
          // 担当者コード・担当者名表示
          methods.setValue("tantoushaCd", auth?.shainCd);
          methods.setValue("tantoushaNm", auth?.shainNm);
          // 登録ボタン活性化
          setDisabledCreateButton(false);
        }
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        methods.setValue("result", getClientError("B010050_001"));
      });
  };

  // ロフトEDIチェック
  const handleLoftEdi = (fields: Fields) => {
    const param: B010050CheckRequest = {
      csvFileData: fields.fileUploadArea!,
    };

    B010050ImportCheckloft(param)
      .then((value) => {
        // 取込結果表示
        methods.setValue("result", value.data.torikomikeka);
        if (value.data.displayDataList) {
          // チェックしたデータの格納作業
          handleDataSaveLoftEdi(value.data);
          // グリッド作成
          handleGridCreate(value.data.displayDataList);
          // ヘッダ入力部活性化
          setDisabledHedder(false);
          // 担当者コード・担当者名表示
          methods.setValue("tantoushaCd", auth?.shainCd);
          methods.setValue("tantoushaNm", auth?.shainNm);
          // 登録ボタン活性化
          setDisabledCreateButton(false);
        }
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        methods.setValue("result", getClientError("B010050_001"));
      });
  };

  // 汎用フォーマットチェック
  const handleGeneric = (fields: Fields) => {
    const param: B010050CheckRequest = {
      csvFileData: fields.fileUploadArea!,
    };

    B010050ImportCheckgeneric(param)
      .then((value) => {
        // 取込結果表示
        methods.setValue("result", value.data.torikomikeka);
        if (value.data.displayDataList) {
          // チェックしたデータの格納作業
          handleDataSaveGeneric(value.data);
          // グリッド作成
          handleGridCreate(value.data.displayDataList);
          // ヘッダ入力部活性化
          setDisabledHedder(false);
          // 担当者コード・担当者名表示
          methods.setValue("tantoushaCd", auth?.shainCd);
          methods.setValue("tantoushaNm", auth?.shainNm);
          // 登録ボタン活性化
          setDisabledCreateButton(false);
        }
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
        methods.setValue("result", getClientError("B010050_001"));
      });
  };

  // 東急ハンズデータ格納処理
  const handleDataSaveTokyuhandsEdi = (data: any) => {
    if (typeof data === "undefined") return;

    checkedDataHandsMethods.setValue("csvFileNm", data.csvFileNm);
    checkedDataHandsMethods.setValue("ediJuchuDataList", data.ediJuchuDataList);
    checkedDataHandsMethods.setValue("displayDataList", data.displayDataList);
  };

  // ロフトデータ格納
  const handleDataSaveLoftEdi = (data: any) => {
    if (typeof data === "undefined") return;

    checkedDataLoftMethods.setValue("csvFileNm", data.csvFileNm);
    checkedDataLoftMethods.setValue("ediJuchuDataList", data.ediJuchuDataList);
    checkedDataLoftMethods.setValue("displayDataList", data.displayDataList);
  };

  // 汎用受注データ格納
  const handleDataSaveGeneric = (data: any) => {
    if (typeof data === "undefined") return;

    checkedDataGenericMethods.setValue("csvFileNm", data.csvFileNm);
    checkedDataGenericMethods.setValue(
      "ediJuchuDataList",
      data.ediJuchuDataList
    );
    checkedDataGenericMethods.setValue("displayDataList", data.displayDataList);
  };

  // データグリッド作成
  const handleGridCreate = (displayDataList: DisplayData[]) => {
    // 行番号設定
    let gyoNo: number = 1;
    // データ設定
    const gridDataList = displayDataList.map<DisplayData>((value) => {
      const data: DisplayData = {
        gyoNo,
        denpyoNo: value.denpyoNo,
        tokuiNm: value.tokuiNm,
        juchuYmd: dateWithSlashAt(value.juchuYmd!),
        meisaisu: value.meisaisu,
        biko: value.biko,
      };
      gyoNo++;
      return data;
    });

    setRows(gridDataList);
  };

  // 登録ボタンクリックイベント
  const handleClickCreateButton = () => {
    //フォームデータ取得
    const fields = methods.getValues();

    // 東急ハンズEDIの場合
    if (fields.torikomidetaKbn?.value === "1") {
      handleTokyuhandsEdiCreate();
    }
    // ロフトEDIの場合
    else if (fields.torikomidetaKbn?.value === "2") {
      handleLoftEdiCreate();
    }
    // 汎用フォーマットの場合
    else if (fields.torikomidetaKbn?.value === "3") {
      handleGenericEdiCreate();
    }
  };

  // 東急ハンズ登録
  const handleTokyuhandsEdiCreate = () => {
    const fields = methods.getValues();
    const savedData = checkedDataHandsMethods.getValues();

    let ediJuchuDataList: B010050EdiJuchuDataHandsRequest[] = [];

    for (const savedJuchuData of savedData.ediJuchuDataList!) {
      const inputData: B010050EdiJuchuDataHandsRequest = {
        hachuYmd: savedJuchuData.hachuYmd!,
        miseCd: savedJuchuData.miseCd!,
        torihikiShohinCd: savedJuchuData.torihikiShohinCd!,
        hachusu: savedJuchuData.hachusu!,
        denpyoNo: savedJuchuData.denpyoNo!,
        tokuiCd: savedJuchuData.tokuiCd!,
        tokuishitenCd: savedJuchuData.tokuishitenCd!,
        shohinNm1: savedJuchuData.shohinNm1,
        shohinNm2: savedJuchuData.shohinNm2,
        gentanka: savedJuchuData.gentanka,
        uritanka: savedJuchuData.uritanka,
        denpyoGyo: savedJuchuData.denpyoGyo,
        floarNm: savedJuchuData.floarNm,
        nohinbasho: savedJuchuData.nohinbasho,
        tekiyo1: savedJuchuData.teikyo1,
        tekiyo2: savedJuchuData.teikyo2,
      };
      ediJuchuDataList.push(inputData);
    }

    const param: B010050ImportHandsRequest = {
      seisakuYmd: fields.seisakuYmd,
      shukayoteiYmd: fields.hasouYmd!,
      denpyoYmd: fields.denpyoYmd!,
      nohinyoteiYmd: fields.nohinyoteiYmd!,
      shainCd: fields.tantoushaCd!,
      asistantCd: fields.assistantCd!,
      csvFileNm: savedData.csvFileNm!,
      denpyoNoList: savedData.displayDataList!.map((value) => {
        return value.denpyoNo!;
      }),
      ediJuchuDataList: ediJuchuDataList,
    };

    B010050ImportHands(param)
      .then((value) => {
        setOpenCreateConfirm(true);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // ロフト登録
  const handleLoftEdiCreate = () => {
    const fields = methods.getValues();
    const savedData = checkedDataLoftMethods.getValues();

    let ediJuchuDataList: B010050EdiJuchuDataLoftRequest[] = [];

    for (const savedJuchuData of savedData.ediJuchuDataList!) {
      const inputData: B010050EdiJuchuDataLoftRequest = {
        hachuTenpo: savedJuchuData.hachuTenpo!,
        hachuYmd: savedJuchuData.hachuYmd!,
        denpyoNo: savedJuchuData.denpyoNo!,
        hinbetsuNo: savedJuchuData.hinbetsuNo!,
        janCd: savedJuchuData.janCd!,
        hachusu: savedJuchuData.hachusu!,
        tokuiCd: savedJuchuData.tokuiCd!,
        tokuishitenCd: savedJuchuData.tokuishitenCd!,
        juchuYmd: savedJuchuData.juchuYmd,
        juchuTime: savedJuchuData.juchuTime,
        biko: savedJuchuData.biko,
        shohinNm: savedJuchuData.shohinNm,
        hachugentanka: savedJuchuData.hachugentanka,
        hachuuritanka: savedJuchuData.hachuuritanka,
      };
      ediJuchuDataList.push(inputData);
    }

    const param: B010050ImportLoftRequest = {
      seisakuYmd: fields.seisakuYmd,
      shukayoteiYmd: fields.hasouYmd!,
      denpyoYmd: fields.denpyoYmd!,
      nohinyoteiYmd: fields.nohinyoteiYmd!,
      shainCd: fields.tantoushaCd!,
      asistantCd: fields.assistantCd!,
      csvFileNm: savedData.csvFileNm!,
      denpyoNoList: savedData.displayDataList!.map((value) => {
        return value.denpyoNo!;
      }),
      ediJuchuDataList: ediJuchuDataList,
    };

    B010050ImportLoft(param)
      .then((value) => {
        setOpenCreateConfirm(true);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 汎用受注データ登録
  const handleGenericEdiCreate = () => {
    const fields = methods.getValues();
    const savedData = checkedDataGenericMethods.getValues();

    let ediJuchuDataList: B010050EdiJuchuDataRequest[] = [];

    for (const savedjuchuData of savedData.ediJuchuDataList!) {
      const inputData: B010050EdiJuchuDataRequest = {
        juchuNo: savedjuchuData.juchuNo!,
        juchuYmd: savedjuchuData.juchuYmd!,
        tokuiCd: savedjuchuData.tokuiCd!,
        tokuishitenCd: savedjuchuData.tokuishitenCd!,
        chohaKbn: savedjuchuData.chohaKbn!,
        shohinCd: savedjuchuData.shohinCd!,
        juchusu: savedjuchuData.juchusu!,
        nonyuCd: savedjuchuData.nonyuCd,
        nonyushitenCd: savedjuchuData.nonyushitenCd,
        seisakuYmd: savedjuchuData.seisakuYmd,
        denpyoYmd: savedjuchuData.denpyoYmd,
        shukayoteiYmd: savedjuchuData.shukayoteiYmd,
        nohinyoteiYmd: savedjuchuData.nohinyoteiYmd,
        biko: savedjuchuData.biko,
        edimemo: savedjuchuData.edimemo,
        chumonNo: savedjuchuData.chumonNo,
        hinbetsuNo: savedjuchuData.hinbetsuNo,
        nohinsaki: savedjuchuData.nohinsaki,
        uribaNm: savedjuchuData.uribaNm,
        naisen: savedjuchuData.naisen,
        tantosha: savedjuchuData.tantosha,
        lineCd: savedjuchuData.lineCd,
        nonyuNm: savedjuchuData.nonyuNm,
        nonyuPostCd: savedjuchuData.nonyuPostCd,
        nonyuAddress1: savedjuchuData.nonyuAddress1,
        nonyuAddress2: savedjuchuData.nonyuAddress2,
        nonyuTelNo: savedjuchuData.nonyuTelNo,
        nonyuFaxNo: savedjuchuData.nonyuFaxNo,
        juchutanka: savedjuchuData.juchutanka,
        juchuKin: savedjuchuData.juchuKin,
        jodaitanka: savedjuchuData.jodaitanka,
        kakeritsu: savedjuchuData.kakeritsu,
        meisaibiko: savedjuchuData.meisaibiko,
      };
      ediJuchuDataList.push(inputData);
    }

    const param: B010050ImportGenericRequest = {
      seisakuYmd: fields.seisakuYmd,
      shukayoteiYmd: fields.hasouYmd!,
      denpyoYmd: fields.denpyoYmd!,
      nohinyoteiYmd: fields.nohinyoteiYmd!,
      shainCd: fields.tantoushaCd!,
      asistantCd: fields.assistantCd!,
      csvFileNm: savedData.csvFileNm!,
      denpyoNoList: savedData.displayDataList!.map((value) => {
        return value.denpyoNo!;
      }),
      ediJuchuDataList: ediJuchuDataList,
    };

    B010050ImportGeneric(param)
      .then((value) => {
        setOpenCreateConfirm(true);
      })
      .catch((reason) => {
        catchRestError(reason, navigate, setMsg);
      });
  };

  // 結果レポート出力
  const handleClickReportButton = () => {
    const text = methods.getValues().result;
    if (typeof text === "undefined") return;
    outputText(text, "受注ワーク取込結果.txt");
  };

  // 完了メッセージダイアログでOK押下時
  const handleOkCompletedConfirm = () => {
    setOpenCreateConfirm(false);

    // 画面遷移処理
    const fields = methods.getValues();
    const inputData: B010070InputData = {
      ediKbn: fields.torikomidetaKbn?.value!,
      juchustatusKbn: "0",
    };

    setMenuNavigate("next");
    navigate("/b010070", { state: inputData });
  };

  // 完了メッセージダイアログでキャンセル押下時(TODO キャンセルボタン無しダイアログ実装後は削除)
  const handleCancelCompletedConfirm = () => {
    setOpenCreateConfirm(false);
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame title="受注ワーク取込" gridTemplateColumns="8rem 10rem">
          <SLabel required gridColumn={1}>
            取込データ種別
          </SLabel>
          <SCodeSelect
            required
            name="torikomidetaKbn"
            options={B010050TorikomidetaKbn}
            {...register(1)}
          />
          <Box />
          <Box display="grid" gridRow={2} gridColumn="span 3">
            <SFileField
              name="fileUploadArea"
              label="取り込む受注データファイル"
              type="csv"
              height="3rem"
            />
          </Box>
          <Box gridColumn="span 3" gridRow={3} />
          <SNormalButton
            label={labels.buttons.read}
            gridRow={4}
            gridColumn={3}
            align="right"
            disabled={disabledReadButton}
            onClick={handleClickReadButton}
            {...register(3)}
          />
          <SText gridRow={5} align="left" gridColumn="span 2">
            受注データファイル読込結果
          </SText>
          <STextArea
            gridRow={6}
            name="result"
            height="5rem"
            {...register(4)}
            disabled
            gridColumn="span 3"
          />
          <SText gridRow={7}> </SText>
          <SFileButton
            gridRow={8}
            label={labels.buttons.resultReport}
            onClick={handleClickReportButton}
            align="right"
            gridColumn={3}
            disabled={disabledReportButton}
          />
        </SFrame>
        <SFrame>
          <SText align="left">受注データ一覧</SText>
          <STable
            keyName="gyoNo"
            data={rows}
            columns={columns}
            tableRef={tableRef}
            width={1280}
            height={300}
          />
        </SFrame>

        <Box
          sx={{
            borderColor: "#4169e1",
            border: 3,
            borderRadius: 1,
            gridColumn: "1",
          }}
          gridTemplateColumns="5rem 2rem 3rem"
        >
          <SFrame
            width={1250}
            gridTemplateColumns="7rem 10rem 1rem 7rem 10rem 15rem"
          >
            <SText gridColumn="span 2" align="left">
              ヘッダ情報一括設定
            </SText>
            <SLabel gridColumn={1}>製作日</SLabel>
            <SDateField
              name="seisakuYmd"
              disabled={disabledHedder}
              {...register(6)}
            />
            <Box />
            <SLabel required>受注担当者</SLabel>
            <SNumberField
              name="tantoushaCd"
              code
              size={7}
              required
              disabled={disabledHedder}
              dialog={<B000140 />}
              handleSubmit={(data: any) => {
                methods.setValue("tantoushaCd", data.shainCd);
                methods.setValue("tantoushaNm", data.shainNm);
              }}
              onBlur={() => B000140TantoushaNm(methods, navigate, setMsg)}
              {...register(10)}
            />
            <STextField name="tantoushaNm" size={40} disabled />

            <SLabel required>発送日</SLabel>
            <SDateField
              name="hasouYmd"
              label="発送日"
              required
              disabled={disabledHedder}
              {...register(7)}
            />
            <Box />
            <SLabel required>アシスタント</SLabel>
            <SNumberField
              name="assistantCd"
              code
              size={7}
              required
              disabled={disabledHedder}
              {...register(11)}
              dialog={<B000140 />}
              handleSubmit={(data: any) => {
                methods.setValue("assistantCd", data.shainCd);
                methods.setValue("assistantNm", data.shainNm);
              }}
              onBlur={() => B000140AssistantNm(methods, navigate, setMsg)}
            />
            <STextField name="assistantNm" size={40} disabled />

            <SLabel required gridColumn={1}>
              伝票日付
            </SLabel>
            <SDateField
              name="denpyoYmd"
              label="伝票日付"
              required
              disabled={disabledHedder}
              {...register(8)}
            />

            <SLabel required gridColumn={1}>
              納品予定日
            </SLabel>
            <SDateField
              name="nohinyoteiYmd"
              label="納品予定日"
              required
              disabled={disabledHedder}
              {...register(9)}
            />
          </SFrame>
        </Box>

        <SFrame gridTemplateColumns="78.3rem ">
          <Box />
          <SNormalButton
            label={labels.buttons.create}
            onClick={handleClickCreateButton}
            align="right"
            disabled={disabledCreateButton}
            {...register(12)}
          />
        </SFrame>

        <SConfirmDialogAction
          msg={labels.dialog.juchuworkImport}
          onOk={handleOkCompletedConfirm}
          onCancel={handleCancelCompletedConfirm}
          isOpen={openCreateConfirm}
        />
      </FormProvider>
    </>
  );
};
